import Box from "@mui/material/Box";
import Image from "next/image";
import { useTranslation } from "react-i18next";

export default function CountryFlag({ width, height, country_code, label = false }) {
	const { t } = useTranslation();

	return (
		<Box display="flex" alignItems="center">
			{label ? t(`country_list.${country_code.toUpperCase()}`) : null}
			<Box
				sx={{
					alignItems: "center",
					display: "flex",
					height: width,
					justifyContent: "center",
					ml: 1,
					mr: 1,
					position: "relative",
					width: height,
				}}
			>
				<Image
					layout="fill"
					style={{ objectFit: "contain" }}
					src={`/img/icons/language/${country_code.toLowerCase()}.svg`}
					alt={t(`country_list.${country_code.toUpperCase()}`)}
				/>
			</Box>
		</Box>
	);
}
